import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { queryKeys } from '../react-query.config';

interface FeedTeam {
  externalId: string;
  leagueId: string;
  name: string;
  abbreviation?: string;
  logoUrl?: string;
  market?: string;
  // Tournament-specific fields (PGA)
  startDate?: string;
  endDate?: string;
  status?: string;
  purse?: number;
  venue?: string;
}

interface FeedTeamsResponse {
  teams: FeedTeam[];
}

export type { FeedTeam };

export const getFeedTeams = async (leagueId: string): Promise<FeedTeam[]> => {
  const response = (await api.get('/feed/teams', {
    params: { leagueId },
  })) as FeedTeamsResponse;
  return response.teams || [];
};

export const useGetFeedTeamsQuery = (leagueId: string | undefined) => {
  return useQuery({
    queryKey: queryKeys.feed.teams(leagueId || ''),
    queryFn: () => getFeedTeams(leagueId!),
    enabled: !!leagueId,
    staleTime: 5 * 60 * 1000, // 5 minutes - teams don't change often
  });
};
